import React from 'react'
import PropTypes from 'prop-types'
import { BUTTON_TEXT } from './constants'
import { Button, Header, Image, ModalOutroWrapper } from './component.styles'

const ModalOutro = ({ buttonOnClick, modalData }) => {
  const { header, image, nextLabel = BUTTON_TEXT } = modalData || {}

  return (
    <ModalOutroWrapper>
      <Image src={image?.file?.url} />
      <Header>{header}</Header>
      <Button dataTestId="outro-button" onClick={buttonOnClick}>
        {nextLabel}
      </Button>
    </ModalOutroWrapper>
  )
}

ModalOutro.propTypes = {
  buttonOnClick: PropTypes.func,
  buttonText: PropTypes.string,
  modalData: PropTypes.shape({
    header: PropTypes.string,
    image: PropTypes.object,
    nextLabel: PropTypes.string,
  }),
}

export default ModalOutro
